/**
 * The rail the user last had focus on, on the Home rails page.
 *
 * Module-level and deliberately in-memory only. It has to outlive `Rails.vue`,
 * which unmounts whenever another nav tab is opened, but a cold-started app
 * should open at the top rather than drop the user halfway down a page they
 * do not remember leaving.
 *
 * Only the rail index is kept, never the cell: `useRailNavigation.resetScroll()`
 * rewinds a rail as focus leaves it, so its first cell is where the user left.
 */

let focusedRailIndex = 0;

export const railFocusMemory = {
  get: (): number => focusedRailIndex,
  set: (index: number) => {
    focusedRailIndex = index;
  },
};
